import {client} from './services/client'

export const historiqueReversementsConfigs = {
    namespaced: true,
    state: {
        historiqueReversementsConfigs: undefined,

    },
    mutations: {
        SET_HISTREVERSEMENT_CONFIGS(state, historiqueReversementsConfigs) {
            state.historiqueReversementsConfigs = historiqueReversementsConfigs
        },

    },
    actions: {
        gethistoriqueReversementsConfigs({commit}, data) {
            return new Promise((resolve, reject) => {
                client({
                    method: 'post',
                    url: '/historiqueReversementsconfigs/get',
                    data: data
                })
                    .then((response) => {
                        commit('SET_HISTREVERSEMENT_CONFIGS', response.data.historiqueReversementsConfigs);
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })

        },

    },
    getters: {
        gethistoriqueReversements: state => {
            return state.historiqueReversements
        },
        gethistoriqueReversementsEnAttente: state => {
            return state.reversemeneas
        },

    }
};
